import HomeContext from 'src/store/home-context';
import formatter from 'src/util/currencyFormatter';
import { Typography } from '@mui/material';
import InfoModal from 'src/components/modal/InfoModal';
import { useContext } from 'react';
import { QUALIFYING_TAX_AMNT } from 'src/constants/global';
/**
 * ItemizeHelpInfoModal is a component that renders an modal with more information about itemizing assets
 *
 * @returns {ReactElement} - A React element that renders the InfoModal component
 */
const ItemizeHelpInfoModal = () => {
  const { itemizeAssetsInfoModal } = useContext(HomeContext);

  const modalContent = (
    <Typography>
      You may declare that your total aggregate business taxable value is{' '}
      {formatter.format(QUALIFYING_TAX_AMNT)} or less without itemizing the equipment. This
      eliminates the need for completing Steps 3 and 4 and you may proceed directly to Step 5 after
      filling out the information below. If your total aggregate business taxable value is more than{' '}
      {formatter.format(QUALIFYING_TAX_AMNT)} or if this is your first year filing you will need to
      complete Steps 2 through 5.
    </Typography>
  );

  return (
    <InfoModal
      open={itemizeAssetsInfoModal.open}
      content={modalContent}
      onClose={itemizeAssetsInfoModal.closeModal}
    />
  );
};

export default ItemizeHelpInfoModal;
